var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.678,
    height: 24.602,
    viewBox: "0 0 27.678 24.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.909,13.839H23.065v4.613l-1.538-1.024-1.538,1.024V13.839H16.145a.771.771,0,0,0-.769.769v9.226a.771.771,0,0,0,.769.769H26.909a.771.771,0,0,0,.769-.769V14.608A.771.771,0,0,0,26.909,13.839ZM8.457,10.764H19.221a.771.771,0,0,0,.769-.769V.769A.771.771,0,0,0,19.221,0H15.377V4.613L13.839,3.589,12.3,4.613V0H8.457a.771.771,0,0,0-.769.769V9.995A.771.771,0,0,0,8.457,10.764Zm3.075,3.075H7.688v4.613L6.151,17.428,4.613,18.452V13.839H.769A.771.771,0,0,0,0,14.608v9.226a.771.771,0,0,0,.769.769H11.532a.771.771,0,0,0,.769-.769V14.608A.771.771,0,0,0,11.532,13.839Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.f359eb5903315929e3c3f16341cd76db.svg";
export { ForwardRef as ReactComponent };